import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PosShiftOpenFormWrapperComponent } from '../components/pos-shift-open-form-wrapper/pos-shift-open-form-wrapper.component';
import { 
  PosShiftOpenFormConfig,
  getPosShiftOpenFormConfig
} from '../pos-shift-open.config';
import { PosShiftOpenService } from '../services/pos-shift-open.service';

@Component({
  selector: 'app-pos-shift-open-view',
  standalone: true,
  imports: [PosShiftOpenFormWrapperComponent],
  templateUrl: './pos-shift-open-view.component.html',
  styleUrls: ['./pos-shift-open-view.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PosShiftOpenViewComponent {
  private posShiftOpenService = inject(PosShiftOpenService);
  
  config: PosShiftOpenFormConfig = {
    ...getPosShiftOpenFormConfig(this.posShiftOpenService),
    title: 'pos.shift_open.form.view_shift_opening'
  };
}

